{
    "NextrunningatLabel": "Volgende hardlopen om:",
    "LastrunatLabel": "Laatste run om:",
    "StatuserrorLabel": "Status \/ Fout:",
    "ScheduleStatus_SectionHeader": "Planningsstatus",
    "NAME": "ScheduleStatus"
}